import React from 'react';
import { Table, Badge, Button } from 'react-bootstrap';
import '../HRBPDetails/HRBPDetails.scss'

const PendingNominationsTable = ({ nominations, onReviewClick }: any) => {
    return (
        <Table striped bordered hover responsive>
            <thead>
                <tr>
                    <th>Employee ID</th>
                    <th>Employee Name</th>
                    <th>Employee E-Mail ID</th>
                    <th>Employee Status</th>
                    <th>Employee Designation</th>
                    <th>Employee Department</th>
                    <th>Employee Project Classification</th>
                    <th>Nominated By</th>
                    <th>Award Category</th>
                    <th>Nomination Date</th>
                    <th>Nomination Reason</th>
                    <th>Status</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                {nominations.length > 0 ? (
                    nominations.map((nomination: any) => (
                        <tr key={nomination._id}>
                            <td>{`${nomination.employeeRef?.employeeId || ''}`}</td>
                            <td>{`${nomination.employeeRef?.candidateName || ''} ${nomination.employeeRef?.lastname || ''}`}</td>
                            <td>{`${nomination?.employeeRef?.emailId || ''}`}</td>
                            <td>
                                <button
                                    type="button"
                                    className={
                                    `${nomination?.employeeRef?.status}` === 'Active'
                                        ? "btn employeedb-status-btn employee-active-btn"
                                        : `${nomination?.employeeRef?.status}`  === "Inactive"
                                        ? "btn employeedb-status-btn employee-inactive-btn"
                                        : `${nomination?.employeeRef?.status}`  === "New"
                                            ? "btn employeedb-status-btn employee-new-btn"
                                            : "btn employeedb-status-btn employee-draft-btn"
                                    }
                                >
                                    {`${nomination?.employeeRef?.status}` || ''} 
                                </button>
                            </td>
                            <td>{`${nomination?.employeeRef?.designation || ''}`}</td>
                            <td>{`${nomination?.employeeRef?.department || ''} - ${nomination.employeeRef?.subDepartment || ''}`}</td>
                            <td>{`${nomination?.employeeRef?.projectType || ''} - ${nomination?.employeeRef?.projectClassification || ''}`}</td>
                            <td>{`${nomination.nominatedByRef?.candidateName || ''} ${nomination.nominatedByRef?.lastname || ''}`}</td>
                            <td>{nomination.awardRef?.awardCategory || 'N/A'}</td>
                            <td>{new Date(nomination.createdAt).toLocaleDateString()}</td>
                            <td>{`${nomination?.justification || ''}`}</td>
                            <td><Badge bg="warning">{nomination.status}</Badge></td>
                            <td>
                                <Button variant="primary" size="sm" onClick={() => onReviewClick(nomination)}>
                                    Review
                                </Button>
                            </td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan={5} className="text-center">No pending nominations found.</td>
                    </tr>
                )}
            </tbody>
        </Table>
    );
};

export default PendingNominationsTable;